import { render, staticRenderFns } from "./RequisitionDisplayView.vue?vue&type=template&id=929a38e6"
import script from "./RequisitionDisplayView.vue?vue&type=script&lang=js"
export * from "./RequisitionDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports